module.exports = __webpack_public_path__ + "img/planet-jupiter.b07a00cd.svg";